import { render, staticRenderFns } from "./MessagePOS.vue?vue&type=template&id=cd153d96&lang=pug"
import script from "./MessagePOS.vue?vue&type=script&lang=js"
export * from "./MessagePOS.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports